export default __webpack_public_path__ + "static/media/case.e835ab44.md";